import { useState, useEffect } from 'react';
import { api } from '../lib/api';

interface Prompts {
  parse: string;
  chat: string;
  activeModel: string;
  flagshipModel: string;
}

export default function SystemPrompts() {
  const [prompts, setPrompts] = useState<Prompts | null>(null);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState<'parse' | 'chat' | null>('chat');

  useEffect(() => {
    api.getSystemPrompts().then(setPrompts).finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-gray-500">Loading...</p>;
  if (!prompts) return <p className="text-red-500">Failed to load prompts</p>;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-2">System Prompts</h1>
      <p className="text-sm text-gray-500 mb-6">
        Read-only view of the AI system prompts used for parsing and chat.
        Active model: <span className="font-mono font-medium text-indigo-600">{prompts.activeModel}</span>
        {' · '}Fallback: <span className="font-mono font-medium text-gray-600">{prompts.flagshipModel}</span>
      </p>

      {/* Chat prompt */}
      <div className="mb-4 border rounded-lg overflow-hidden">
        <button
          className="w-full text-left px-4 py-3 bg-gray-50 hover:bg-gray-100 flex justify-between items-center"
          onClick={() => setExpanded(expanded === 'chat' ? null : 'chat')}
        >
          <span className="font-semibold text-sm">Chat System Prompt</span>
          <span className="text-xs text-gray-400">{prompts.chat.length} chars</span>
        </button>
        {expanded === 'chat' && (
          <pre className="px-4 py-3 text-xs leading-relaxed whitespace-pre-wrap bg-white overflow-auto max-h-[60vh] font-mono text-gray-700">
            {prompts.chat}
          </pre>
        )}
      </div>

      {/* Parse prompt */}
      <div className="border rounded-lg overflow-hidden">
        <button
          className="w-full text-left px-4 py-3 bg-gray-50 hover:bg-gray-100 flex justify-between items-center"
          onClick={() => setExpanded(expanded === 'parse' ? null : 'parse')}
        >
          <span className="font-semibold text-sm">Parse System Prompt</span>
          <span className="text-xs text-gray-400">{prompts.parse.length} chars</span>
        </button>
        {expanded === 'parse' && (
          <pre className="px-4 py-3 text-xs leading-relaxed whitespace-pre-wrap bg-white overflow-auto max-h-[60vh] font-mono text-gray-700">
            {prompts.parse}
          </pre>
        )}
      </div>
    </div>
  );
}
